export default "__VITE_ASSET__BJnEEBNN__"